import { RemovableCard } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';

import { ConversationsBulkTextEditor } from 'components/conversation';

import {
  BulkModalActionBaseProps,
  BulkModalInternalNoteAction,
} from '../../../types/conversationsBulkModal.types';
import { conversationsBulkModalActionLabel } from '../../../utils/conversationsBulkModalActionLabel';

type ConversationsBulkModalInternalNoteActionProps =
  BulkModalActionBaseProps<BulkModalInternalNoteAction>;

/**
 * Represents the component for the conversations bulk modal internal note
 * action.
 */
export const ConversationsBulkModalInternalNoteAction = ({
  conversationIds,
  onChange,
  onRemove,
}: ConversationsBulkModalInternalNoteActionProps): JSX.Element => {
  const [text, setText] = useState('');

  useEffect(
    () =>
      onChange({
        type: 'add_internal_note',
        isValid: text.trim().length > 0,
        arg: {
          csids: conversationIds,
          text,
        },
      }),
    [conversationIds, onChange, text],
  );

  const handleChange = useCallback((htmlText: string) => {
    setText(htmlText);
  }, []);

  return (
    <RemovableCard
      icon="sticky-note"
      title={conversationsBulkModalActionLabel['add_internal_note']}
      onRemove={() => onRemove('add_internal_note')}
    >
      <ConversationsBulkTextEditor
        type="add_internal_note"
        onChange={handleChange}
      />
    </RemovableCard>
  );
};
